import { PaintRowDraft } from '../types'
import { getBrandReference } from './get-brand-reference'
import { isCompositionChanged } from './is-composition-changed'
import { toCellDrafts } from './to-cell-drafts'

/**
 * Переключение бренда: выбранным рецептом становится эталон бренда (рецепт без версии).
 * Если состав не меняли — подставляется состав эталона, иначе правки печатника сохраняются.
 */
export function switchBrand(draft: PaintRowDraft, manufacturerDocumentId: string): PaintRowDraft {
    const reference = getBrandReference(draft, manufacturerDocumentId)

    return {
        ...draft,
        manufacturerDocumentId,
        referencePantoneDocumentId: reference?.documentId ?? null,
        colorants: isCompositionChanged(draft)
            ? draft.colorants
            : toCellDrafts(reference?.colorants),
    }
}
